import { injectJs } from './document';

// Ð”Ð»Ñ Ð½Ð°ÑˆÐµÐ³Ð¾ ÑÑ‡ÐµÑ‚Ñ‡Ð¸ÐºÐ° 26812653 Ð² Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐµ ÐµÑÑ‚ÑŒ ÑƒÑÐ»Ð¾Ð²Ð¸Ðµ, ÐºÐ¾Ñ‚Ð¾Ñ€Ð¾Ðµ Ð·Ð°Ð¿Ñ€ÐµÑ‰Ð°ÐµÑ‚ Ð»Ð¾Ð³Ð¸Ñ€Ð¾Ð²Ð°Ð½Ð¸Ðµ Ñ Ð¿Ð¾Ð¼Ð¾Ñ‰ÑŒÑŽ _ym_debug=1
// Ð’Ð¾Ð·Ð¼Ð¾Ð¶Ð½Ð¾ Ð¿Ñ€Ð¾Ð²ÐµÑ€Ð¸Ñ‚ÑŒ ÐºÐ¾Ñ€Ñ€ÐµÐºÑ‚Ð½Ð¾ÑÑ‚ÑŒ Ñ Ð¿Ð¾Ð¼Ð¾Ñ‰ÑŒÑŽ "Ð¿Ð»Ð°Ð³Ð¸Ð½Ð° Ð¾Ñ‚ Ð¸ÑÐ¿Ð°Ð½Ñ†Ð°" https://st.yandex-team.ru/METRIKASUPP-11524#606c867289492e172e848a5d

/**
 * Ð˜Ñ‰ÐµÑ‚ Ð½Ð° ÑÑ‚Ñ€Ð°Ð½Ð¸Ñ†Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑŽÑ‡ÐµÐ½Ð½Ñ‹Ð¹ ÑÐºÑ€Ð¸Ð¿Ñ‚ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ¸
 */
function hasMetrikaScriptInDOM(scriptName, scriptTags) {
    const metrikaUrlRegExp = new RegExp(`^https://mc\\.yandex\\.ru/metrika/${scriptName}\\.js$`);
    const cdnUrlRegExp = new RegExp(`^https://cdn\\.jsdelivr\\.net/npm/yandex-metrica-watch/${scriptName}\\.js$`);

    return scriptTags.some(({ src }) =>
        metrikaUrlRegExp.test(src) ||
        cdnUrlRegExp.test(src)
    );
}

/**
 * ÐŸÑ€Ð¾Ð²ÐµÑ€ÑÐµÑ‚, Ð¸Ð½Ð¸Ñ†Ð¸Ð°Ð»Ð¸Ð·Ð¸Ñ€Ð¾Ð²Ð°Ð½Ð° Ð¿ÐµÑ€Ð²Ð°Ñ Ð¸Ð»Ð¸ Ð²Ñ‚Ð¾Ñ€Ð°Ñ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ° Ð½Ð° ÑÑ‚Ñ€Ð°Ð½Ð¸Ñ†Ðµ
 */
function hasMetrikaInWindow() {
    return window.Ya && ('Metrika' in window.Ya || 'Metrika2' in window.Ya);
}

/**
 * ÐŸÑ€Ð¾Ð²ÐµÑ€ÑÐµÑ‚, ÐµÑÑ‚ÑŒ Ð»Ð¸ Ð² window Ð¼ÐµÑ‚Ñ€Ð¸Ñ‡Ð½Ð°Ñ Ñ„ÑƒÐ½ÐºÑ†Ð¸Ñ ym()
 */
function hasYmInWindow() {
    return Boolean(window.ym);
}

/**
 * ÐŸÑ€Ð¾Ð²ÐµÑ€ÑÐµÑ‚, Ð²Ð°Ð»Ð¸Ð´Ð½Ð°Ñ Ð»Ð¸ Ð¼ÐµÑ‚Ñ€Ð¸Ñ‡Ð½Ð°Ñ Ñ„ÑƒÐ½ÐºÑ†Ð¸Ñ ym()
 */
function isValidYm() {
    return Array.isArray(window.ym.a);
}

/**
 * ÐŸÑ€Ð¾Ð²ÐµÑ€ÑÐµÑ‚, ÐµÑÑ‚ÑŒ Ð»Ð¸ Ð¿ÐµÑ€Ð²Ð°Ñ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ° Ð² window
 */
function hasFirstMetrikaInWindow() {
    return window.Ya.Metrika && !window.Ya.Metrika2;
}

class Metrika {
    constructor(id) {
        this._id = id;
        this.strategy = {
            value: ''
        };

        this.traceMethod = this.traceMethod.bind(this);
    }

    traceMethod(name) {
        this.strategy.value += this.strategy.value ? `/${name}` : name;
    }

    /**
     * Ð’Ñ‹Ð·Ð¾Ð²ÐµÑ‚ Ñ„ÑƒÐ½ÐºÑ†Ð¸ÑŽ, ÐºÐ¾Ð³Ð´Ð° Ð±ÑƒÐ´ÐµÑ‚ Ð·Ð°Ð³Ñ€ÑƒÐ¶ÐµÐ½Ð° Ð²Ñ‚Ð¾Ñ€Ð°Ñ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ°
     * @param {function} callback
     */
    pushCallback(callback) {
        const namespace = 'yandex_metrika_callbacks2'; // Ð•ÑÐ»Ð¸ Ð¸Ð½Ð¸Ñ†Ð¸Ð°Ð»Ð¸Ð·Ð¸Ñ€ÑƒÐµÐ¼ Ñ‡ÐµÑ€ÐµÐ· pushCallback, Ñ‚Ð¾ Ð²ÑÐµÐ³Ð´Ð° Ð³Ñ€ÑƒÐ·Ð¸Ñ‚ÑÑ Ð²Ñ‚Ð¾Ñ€Ð°Ñ Ð²ÐµÑ€ÑÐ¸Ñ

        window[namespace] = window[namespace] || [];
        window[namespace].push(callback);
    }

    /**
     * Ð¡Ñ‚Ð°Ð±Ð°ÐµÑ‚ Ñ„ÑƒÐ½ÐºÑ†Ð¸ÑŽ ym Ñ‚Ð°Ðº, Ñ‡Ñ‚Ð¾Ð±Ñ‹ ÑÐ¸Ð³Ð½Ð°Ñ‚ÑƒÑ€Ð° ÑÐ¾Ð²Ð¿Ð°Ð´Ð°Ð»Ð° ÑÐ¾ ÑÑ‚Ð°Ð½Ð´Ð°Ñ€Ñ‚Ð½Ð¾Ð¹ Ñ„ÑƒÐ½ÐºÑ†Ð¸ÐµÐ¹ Ð¸ÑÐ¿Ð¾Ð»ÑŒÐ·Ð¾Ð²Ð°Ð½Ð¸Ñ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ¸
     * @param {string} metrikaConstructorName
     */
    stubYm(metrikaConstructorName) {
        this.traceMethod(metrikaConstructorName === 'Metrika' ? 'h' : 'i');
        let metrika;

        this.ym = (method, ...options) => {
            if (method === 'init') {
                const MetrikaConstructor = window.Ya[metrikaConstructorName];
                metrika = new MetrikaConstructor({ id: this._id, ...options[0] });
            } else {
                metrika[method](...options);
            }
        };
    }

    /**
     * Ð˜Ð¼Ð¿Ð»ÐµÐ¼ÐµÐ½Ñ‚Ð¸Ñ€ÑƒÐµÑ‚ ÑÑ‚Ð°Ð½Ð´Ð°Ñ€Ñ‚Ð½ÑƒÑŽ Ñ„ÑƒÐ½ÐºÑ†Ð¸ÑŽ Ð¸ÑÐ¿Ð¾Ð»ÑŒÐ·Ð¾Ð²Ð°Ð½Ð¸Ñ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ¸
     */
    injectYm() {
        window.ym = (...args) => window.ym.a.push(args);

        window.ym.a = [];

        this.ym = window.ym.bind(null, this._id);
    }

    /**
     * Ð˜Ð¼Ð¿Ð»ÐµÐ¼ÐµÐ½Ñ‚Ð¸Ñ€ÑƒÐµÑ‚ this.ym Ð´Ð»Ñ Ð¸ÑÐ¿Ð¾Ð»ÑŒÐ·Ð¾Ð²Ð°Ð½Ð¸Ñ Ð²Ñ‚Ð¾Ñ€Ð¾Ð¹ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ¸
     */
    setYmMethodForMetrika2() {
        this.traceMethod('n');
        if (hasYmInWindow()) {
            if (isValidYm()) {
                this.traceMethod('o');
                // Ð¤ÑƒÐ½ÐºÑ†Ð¸Ñ ym() ÐµÑÑ‚ÑŒ Ð¸ Ð²Ð°Ð»Ð¸Ð´Ð½Ð°Ñ
                this.ym = window.ym.bind(null, this._id);
            } else {
                this.traceMethod('p');
                // Ð¤ÑƒÐ½ÐºÑ†Ð¸Ñ ym() ÐµÑÑ‚ÑŒ, Ð½Ð¾ Ð½Ðµ Ð²Ð°Ð»Ð¸Ð´Ð½Ð°Ñ (Ð½Ð°Ð¿Ñ€Ð¸Ð¼ÐµÑ€, Ð¾Ñ‚ Ð²ÐµÐ±Ð¼Ð°ÑÑ‚ÐµÑ€Ð°)
                this.stubYm('Metrika2');
            }
        } else {
            this.traceMethod('q');
            // ÐÐµÑ‚ Ñ„ÑƒÐ½ÐºÑ†Ð¸Ð¸ ym()
            this.injectYm();
        }
    }

    /**
     * Ð˜Ð½Ð¶ÐµÐºÑ‚Ð¸Ð¼ Ñ€ÑƒÐºÐ°Ð¼Ð¸ ÑÐºÑ€Ð¸Ð¿Ñ‚ Ð·Ð°Ð³Ñ€ÑƒÐ·ÐºÐ¸ Ð²Ñ‚Ð¾Ñ€Ð¾Ð¹ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ¸ Ð½Ð° ÑÑ‚Ñ€Ð°Ð½Ð¸Ñ†Ðµ
     */
    injectMetrikaScript() {
        this.setYmMethodForMetrika2();

        this.traceMethod('r');
        const script = injectJs('https://mc.yandex.ru/metrika/tag.js');

        this.pushCallback(() => {
            this.traceMethod('s');
            this.initYm();

            if (script) {
                script.parentNode.removeChild(script);
            }
        });
    }

    /**
     * Ð–Ð´ÐµÐ¼, Ð¿Ð¾ÐºÐ° Ð¿Ð¾Ð´Ð³Ñ€ÑƒÐ·Ð¸Ñ‚ÑÑ Ð¸Ð¼ÐµÑŽÑ‰Ð¸Ð¹ÑÑ Ð² DOM ÑÐºÑ€Ð¸Ð¿Ñ‚ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ¸
     */
    waitMetrikaLoading() {
        this.traceMethod('j');

        let intervalTimer = null;
        let timeoutTimer = null;

        const checkMetrikaInit = () => {
            this.traceMethod('k');
            // Ð•ÑÐ»Ð¸ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ° Ð¸Ð½Ð¸Ñ†Ð¸Ð°Ð»Ð¸Ð·Ð¾Ð²Ð°Ð»Ð°ÑÑŒ, Ñ‡Ð¸ÑÑ‚Ð¸Ð¼ Ð²ÑÐµ Ñ‚Ð°Ð¹Ð¼ÐµÑ€Ñ‹ Ð¸ ÑÐ¾Ð·Ð´Ð°ÐµÐ¼ ÑÑ‡ÐµÑ‚Ñ‡Ð¸Ðº
            if (hasMetrikaInWindow()) {
                this.traceMethod('l');
                clearInterval(intervalTimer);
                clearTimeout(timeoutTimer);

                this.initYm();

                return true;
            }
        };

        intervalTimer = setInterval(checkMetrikaInit, 45);

        const timeoutStrategy = () => {
            if (checkMetrikaInit()) {
                return;
            }

            this.traceMethod('m');
            // Ð•ÑÐ»Ð¸ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ° Ð½Ðµ Ð¸Ð½Ð¸Ñ†Ð¸Ð°Ð»Ð¸Ð·Ð¾Ð²Ð°Ð»Ð°ÑÑŒ ÑÐ¿ÑƒÑÑ‚Ñ 400Ð¼Ñ, Ð¸Ð½Ð¶ÐµÐºÑ‚Ð¸Ð¼ ÑÐºÑ€Ð¸Ð¿Ñ‚ Ð·Ð°Ð³Ñ€ÑƒÐ·ÐºÐ¸
            clearInterval(intervalTimer);

            this.injectMetrikaScript();
        };

        timeoutTimer = setTimeout(timeoutStrategy, 400);
    }

    tagJsLoadingStrategy() {
        this.setYmMethodForMetrika2();
        this.waitMetrikaLoading();
    }

    watchJsLoadingStrategy() {
        this.stubYm('Metrika');
        this.waitMetrikaLoading();
    }

    hasMetrikaStrategy() {
        switch (true) {
            // ÐŸÐµÑ€Ð²Ð°Ñ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ°
            case (hasFirstMetrikaInWindow()): {
                this.traceMethod('e');
                this.stubYm('Metrika');
                break;
            }

            // Ð’Ñ‚Ð¾Ñ€Ð°Ñ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ° Ð¸ ÐµÑÑ‚ÑŒ Ð²Ð°Ð»Ð¸Ð´Ð½Ð°Ñ Ñ„ÑƒÐ½ÐºÑ†Ð¸Ñ ym()
            case (hasYmInWindow() && isValidYm()): {
                this.traceMethod('f');
                this.ym = window.ym.bind(null, this._id);
                break;
            }

            // Ð’Ñ‚Ð¾Ñ€Ð°Ñ Ð¼ÐµÑ‚Ñ€Ð¸ÐºÐ° Ð¸ Ð½ÐµÑ‚ Ð²Ð°Ð»Ð¸Ð´Ð½Ð¾Ð¹ ym()
            default: {
                this.traceMethod('g');
                this.stubYm('Metrika2');
                break;
            }
        }

        this.initYm();
    }

    init() {
        if (hasMetrikaInWindow()) {
            this.traceMethod('a');
            return this.hasMetrikaStrategy();
        }

        const scriptTags = Array.prototype.slice.call(document.getElementsByTagName('script'));
        if (hasMetrikaScriptInDOM('watch', scriptTags)) {
            this.traceMethod('b');
            return this.watchJsLoadingStrategy();
        }

        if (hasMetrikaScriptInDOM('tag', scriptTags)) {
            this.traceMethod('c');
            return this.tagJsLoadingStrategy();
        }

        this.traceMethod('d');
        this.injectMetrikaScript();
    }

    /**
     * Ð˜Ð½Ð¸Ñ†Ð¸Ð°Ð»Ð¸Ð·Ð°Ñ†Ð¸Ñ ÑÑ‡ÐµÑ‚Ñ‡Ð¸ÐºÐ°
     */
    initYm() {
        this.traceMethod('t');

        this.ym('init', {
            trackLinks: true,
            accurateTrackBounce: true,
            params: {
                shareVersion: 2,
                strategy: this.strategy.value
            },
            triggerEvent: true
        });
    }
}

export default Metrika;
